import React, { useRef, useEffect, useState, useCallback } from 'react';
import { Switch } from 'devextreme-react';
import AssetsService from "api/assets.service";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import { useHistory } from "react-router";


export default function ActionsTab({ assetId }) {
    const [checkBoxValue, setCheckBoxValue] = useState(false);
    const [isPopupVisible, setisPopupVisible] = useState(false)
    const history = useHistory();

    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 5000,
    });

    const onValueChanged = useCallback(async (event) => {
        await setCheckBoxValue(!checkBoxValue);
        await AssetsService.sendCommand(assetId, "CHECKIN", !checkBoxValue, !checkBoxValue).then((response) => {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response?.data?.status ? response.data.status : response?.status,
                message: response?.data?.message ? response.data.message : response?.message,
            });
            if (response.status === 200) setCheckBoxValue(!checkBoxValue);
        })
    }, [checkBoxValue]);

    function manageBtn(isNotifiedVal, isPopupVisibleVal) {
        wakeUpBtn(isNotifiedVal)
        setisPopupVisible(isPopupVisibleVal)
        setTimeout(() => {
            history.push('/assets')
        }, 1000);
    }

    const wakeUpBtn = (isNotification) => {
        AssetsService.sendCommand(assetId, "WAKEUP", isNotification, isNotification).then((response) => {
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: response.status === 200 ? 'success' : 'error',
                status: response?.data?.status ? response.data.status : response?.status,
                message: response?.data?.message ? response.data.message : response?.message,
            });
        })
    }

    function beepBtn() {
        AssetsService.sendCommand(assetId, "RETRIEVE").then(async (response) => {
            if (response.status === 200) {
                await setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: response.status === 200 ? 'success' : 'error',
                    status: response?.data?.status ? response.data.status : response?.status,
                    message: response?.data?.message ? response.data.message : response?.message,
                });
            } else {
                await setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: 'error',
                    status: 400,
                    message: 'Cannot retrieve asset because no device paired to asset.',
                });
            }
        }).catch((err) => {
            console.error('Error:', err);
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: 'error',
                status: 400,
                message: 'Cannot retrieve asset because no device paired to asset.',
            });
        })
    }

    const renderContent = () => {
        return (
            <>Do you want to receive a notification when the device is ready for retrieval?</>
        );
    };

    function hidePopup() {
        setisPopupVisible(false)
    }

    const acceptOptions = {
        text: 'Yes',
        onClick: function (e) {
            manageBtn(true, false)
        }
    };
    const rejectOptions = {
        text: 'No',
        onClick: function (e) {
            manageBtn(false, false)
        }
    };



    return (
        <div className='actions-container'>
            <div className='assetTab-checkboxContainer'>
                <div className='assetTab-checkboxText'>
                    Asset Checked &nbsp;  &nbsp; OUT
                </div>
                <div className='assetTab-checkbox'>
                    <Switch
                        value={checkBoxValue}
                        onValueChanged={onValueChanged}
                        text={"Asset checked"}
                        iconSize={39}
                        switchedOnText={"On"}
                    />
                </div>
                <div className='assetTab-checkboxText'>
                    IN
                </div>
            </div>
            <div className='ActionsPage'>
                {/* <Button
                            height={41}
                            className={'wakeUpBtn'}
                            text="Text"
                            type="normal"
                            stylingMode="outlined"
                            onClick={() => wakeUpBtn(true)}
                        >
                            Wake Up
                        </Button>

                        <Button
                            height={41}
                            className={'beepBtn'}
                            text="Text"
                            type="normal"
                            stylingMode="outlined"
                            onClick={beepBtn}
                            style={{marginLeft:"10px"}}
                        >
                            Retrieve
                        </Button> */}

                <div>
                    <button className='profile-save' onClick={() => wakeUpBtn(true)}>WAKE UP</button>
                    <button className='profile-save' onClick={beepBtn}>RETRIEVE</button>
                </div>

                <Popup
                    title="Confirm"
                    showTitle={true}
                    visible={isPopupVisible}
                    contentRender={renderContent}
                    onHiding={hidePopup}
                    hideOnOutsideClick={false}
                    showCloseButton={true}
                    width={300}
                    height={"auto"}
                >
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="before"
                        options={acceptOptions}
                    />
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={rejectOptions}
                    />
                </Popup>
            </div>
        </div>
    );
}